import { useState } from 'react';

export default function useToggleData(initialValue = {}) {
  const [value, setValue] = useState(initialValue);
  const toggle = data => setValue(x => ({ ...x, [data]: !x[data] }));

  return [value, toggle];
}
